// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import FormattedNumberInput from '../../formatted-number-input';

class InputRange extends Component {

    state = {
        max: this.props.max,
        min: this.props.min
    };

    componentWillReceiveProps = nextProps => {

        this.setState({
            max: nextProps.max,
            min: nextProps.min
        });

    };

    handleMinimumChange = value => {

        const newMinimum = value;

        const newRange = {
            max: this.state.max,
            min: newMinimum
        };

        const isValidRange = this.props.isValidRange(newRange);

        if (isValidRange) {

            this.setState({
                min: newMinimum
            });

            this.props.onInputRangeChange(newRange);

        } else {

            this.setState({
                min: this.state.min
            });

        }

    };

    handleMaximumChange = value => {

        const newMaximum = value;

        const newRange = {
            max: newMaximum,
            min: this.state.min
        };

        const isValidRange = this.props.isValidRange(newRange);

        if (isValidRange) {

            this.setState({
                max: newMaximum
            });

            this.props.onInputRangeChange(newRange);

        } else {

            this.setState({
                max: this.state.max
            });

        }

    };

    render() {

        return (
            <section className='input-range'>
                <FormattedNumberInput
                    allowNegative={false}
                    decimalPrecision={2}
                    onBlur={this.handleMinimumChange}
                    onValueChange={() => ({})}
                    placeholder={this.props.minimumRangePlaceholder}
                    value={this.state.min}
                />
                <FormattedNumberInput
                    allowNegative={false}
                    decimalPrecision={2}
                    onBlur={this.handleMaximumChange}
                    onValueChange={() => ({})}
                    placeholder={this.props.maximumRangePlaceholder}
                    value={this.state.max}
                />
            </section>
        );

    }

}

InputRange.displayName = 'InputRange';
InputRange.propTypes = {
    isValidRange: PropTypes.func.isRequired,
    max: PropTypes.number,
    maximumRangePlaceholder: PropTypes.string,
    min: PropTypes.number,
    minimumRangePlaceholder: PropTypes.string,
    onInputRangeChange: PropTypes.func.isRequired
};
InputRange.defaultProps = {
    maximumRangePlaceholder: 'TO',
    minimumRangePlaceholder: 'FROM'
};

export default InputRange;



// WEBPACK FOOTER //
// ./src/shared/components/facets/input-range/index.js